<template>
  <div>
    <transition name="fade">
      <div v-if="show && isConnectionError" class="connection-error" transition="fade">
        <span class="glyphicon glyphicon-flash blink"></span>
        {{ $t('error.connection') }}
        <a class="close" @click.stop.prevent="show = false">×</a>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="show && !isConnectionError" class="error-mask"
          :class="{'modal-mask': modal, 'banner-mask': !modal}">
        <a class="close" @click.stop.prevent="show = false">❌</a>
        <div :class="{'modal-wrapper': modal, 'banner-wrapper': !modal}">
          <div :class="{'modal-container': modal, 'banner-container': !modal}">
            <div v-show="isServerError">
              <h2>{{ $t('error.generic') }}</h2>
              <p v-html="$t('error.server')"></p>
              <br />
              <p v-html="$t('error.apologies')"></p>
              <p v-html="$t('error.help')"></p>
            </div>
            <div v-show="isForbidden">
              <h2>{{ $t('error.access_denied') }}</h2>
              <br />
              <p>{{ $t('error.forbidden') }}</p>
              <p><span v-html="$t('error.contact_us')"></span></p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// Error component
// Hooks into global error events and is responsible for showing errors to the user.
// Can be modal or non-modal.

import events from '../services/events'

export default {
  data: function () {
    return {
      show: false,
      error: '',
      modal: true
    }
  },
  mounted: function () {
    events.bus.$on('error', this.handleError)
  },
  beforeDestroy: function () {
    events.bus.$off('error', this.handleError)
  },
  methods: {
    handleError: function (error, message, options) {
      console.log(error, message, options)
      this.error = error.response ? error.response.status : 0
      if (options && options.modal === false) {
        this.modal = false
      } else {
        this.modal = true
      }
      if (parseInt(this.error) !== 401) {
        this.show = true
      }
    }
  },
  computed: {
    errorCode: function () {
      return parseInt(this.error)
    },
    isForbidden: function () {
      return this.errorCode === 403
    },
    isServerError: function () {
      return this.errorCode >= 500
    },
    isConnectionError: function () {
      return this.errorCode === 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// Error.vue?07cd7020